"use client";
import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";

export function PwaUpdatePrompt() {
  const t = useTranslations("pwa.update");
  const [waiting, setWaiting] = useState<ServiceWorker | null>(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(/Mobi|Android|iPad|Tablet/i.test(navigator.userAgent));
  }, []);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker.ready.then((reg) => {
      if (reg.waiting) setWaiting(reg.waiting);
      reg.addEventListener("updatefound", () => {
        const sw = reg.installing;
        sw?.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) {
            setWaiting(sw);
          }
        });
      });
    });
  }, []);

  if (!waiting || !isMobile) return null;

  return (
    <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-3 px-4 py-2.5 rounded-xl border border-base shadow-lg"
      style={{ background: "rgb(var(--bg-sidebar))" }}>
      <span className="text-sm">{t("available")}</span>
      <button
        className="text-sm font-medium px-3 py-1 rounded-lg"
        style={{ background: "rgb(var(--accent))", color: "#fff" }}
        onClick={() => {
          waiting.postMessage({ type: "SKIP_WAITING" });
          window.location.reload();
        }}
      >
        {t("button")}
      </button>
    </div>
  );
}